import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Modal, WhiteButton } from 'components';
import { IModalAction } from 'models/modal';
import { showModal, closeModal } from 'modules/modal';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import LocationFilter from '../FilterFields/LocationFilter';
import DateFilter from '../FilterFields/DateFilter';
import HoursFilter from '../FilterFields/HoursFilter';
import { deleteURLSearchParams, readURLSearchParams } from 'helpers/common';
import { browserHistory } from 'react-router';
import {
	setDateFilter,
	setLocationFilter,
	setLocationFilteringStatus,
	setPreviousLocation,
	setTimeFilter,
} from 'redux/modules/shop/offices';
import { ISearchGeoCoordinates } from 'models/shop/office';

interface IState {
	locationReset?: () => void;
	dateReset?: () => void;
	timeReset?: () => void;
	sortReset?: () => void;
}

interface IProps {
	showHeaderCloseButton: boolean;
	previousLatitude?: number;
	previousLongitude?: number;
	/* func props */
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;

	setLocationFilteringStatus?: (status: boolean) => void;
	setPreviousLocation: (latitude: number, longitude: number) => void;
	setLocationFilter?: (locationFilter: ISearchGeoCoordinates) => void;
	setDateFilter?: (dateFilter: number) => void;
	setTimeFilter?: (timeFilter: { openTime?: number; closeTime?: number; utcOffset: number }) => void;
}

@connect(
	(state: IStore) => ({
		previousLatitude: state.offices?.previousGeoCoordinates?.latitude,
		previousLongitude: state.offices?.previousGeoCoordinates?.longitude,
	}),
	(dispatch) => ({
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		setLocationFilteringStatus: (status: boolean) => dispatch(setLocationFilteringStatus(status)),
		setLocationFilter: (locationFilter: ISearchGeoCoordinates) => dispatch(setLocationFilter(locationFilter)),
		setPreviousLocation: (latitude: number, longitude: number) => dispatch(setPreviousLocation(latitude, longitude)),
		setDateFilter: (dateFilter: number) => dispatch(setDateFilter(dateFilter)),
		setTimeFilter: (timeFilter: { openTime?: number; closeTime?: number; utcOffset: number }) =>
			dispatch(setTimeFilter(timeFilter)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SetFiltersModal extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.state = {
			locationReset: readURLSearchParams(c.SHOPS_LOCATION_FILTER) ? this.handleLocationReset : null,
			dateReset: readURLSearchParams(c.SHOPS_DATE_FILTER) ? this.handleDateReset : null,
			timeReset:
				readURLSearchParams(c.SHOPS_HOURS_FILTER + 'Min') || readURLSearchParams(c.SHOPS_HOURS_FILTER + 'Max')
					? this.handleTimeReset
					: null,
			sortReset: readURLSearchParams(c.SHOPS_SORT_FILTER) ? this.handleSortReset : null,
		};
		this.handleLocationReset = this.handleLocationReset.bind(this);
		this.handleDateReset = this.handleDateReset.bind(this);
		this.handleTimeReset = this.handleTimeReset.bind(this);
		this.handleSortReset = this.handleSortReset.bind(this);
	}
	history = browserHistory;

	public handleLocationReset(x?: any) {
		// need to pass 'this' inside as bidning doesn't work?!?!
		deleteURLSearchParams(
			[c.SHOPS_LOCATION_FILTER, c.SHOPS_LOCATION_FILTER_LAT, c.SHOPS_LOCATION_FILTER_LNG],
			x.history,
		);
		x.setState({ locationReset: null });
		x.props.setLocationFilter({
			latitude: x.props.previousLatitude,
			longitude: x.props.previousLongitude,
			distance: c.SALONS_DEFAULT_MAX_DISTANCE,
		});
		x.props.setLocationFilteringStatus(false);
		x.props.setPreviousLocation(null, null);
	}
	public handleDateReset(x?: any) {
		// need to pass 'this' inside as bidning doesn't work?!?!
		deleteURLSearchParams([c.SHOPS_DATE_FILTER], x.history);
		x.setState({ dateReset: null });
		x.props.setDateFilter(null);
	}
	public handleTimeReset(x?: any) {
		// need to pass 'this' inside as bidning doesn't work?!?!
		deleteURLSearchParams([c.SHOPS_HOURS_FILTER + 'Min', c.SHOPS_HOURS_FILTER + 'Max'], x.history);
		x.props.setTimeFilter(null);
	}
	public handleSortReset(x?: any) {
		// need to pass 'this' inside as bidning doesn't work?!?!
		deleteURLSearchParams([c.SHOPS_SORT_FILTER], x.history);
		x.setState({ sortReset: null });
	}

	public render() {
		const { showHeaderCloseButton, closeModal, t } = this.props;
		const { locationReset, dateReset, timeReset } = this.state;

		const handleLocationChange = (value: string) => {
			if (value.length) {
				this.setState({ locationReset: this.handleLocationReset });
			}
		};
		const handleDateChange = (value: string) => {
			if (value.length) {
				this.setState({ dateReset: this.handleDateReset });
			}
		};
		const handleTimeChange = ({ min, max }: { min: number; max: number }) => {
			if ((min || max !== 1440) && !this.state.timeReset) {
				//1440 === 24h in minutes
				this.setState({ timeReset: this.handleTimeReset });
			} else if (min === 0 && max === 1440 && this.state.timeReset) {
				this.setState({ timeReset: null });
			}
		};

		const sectionTitle = (text: string, resetAction?: (x: any) => void): JSX.Element => {
			return (
				<>
					<div className="sectionDivider" />
					<div className="sectionTitleContainer">
						<p className="p14">{text.toUpperCase()}</p>
						{resetAction ? (
							<div onClick={() => resetAction(this)} className="pointer">
								{t('BSPortal_Common_Reset')}
							</div>
						) : null}
					</div>
				</>
			);
		};

		return (
			<Modal
				title={t('Search_Salons_Filter_Title')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				modalClass={`setFiltersModal `}
				scrollModalToTopOnOpen={true}
				stickyHeader={true}
			>
				<div className="row">
					<div className="col-md-12">
						{sectionTitle(t('Shop_ManageShop_General_Label_Location'), locationReset)}
						<LocationFilter onChange={handleLocationChange} />
						{sectionTitle(t('BSPortal_Common_Date'), dateReset)}
						<DateFilter displayOnlyDatepicker={true} onChange={handleDateChange} />
						{sectionTitle(t('BookAppointment_Schedule_Filter_Time'), timeReset)}
						<HoursFilter displayOnlyRangeSlider={true} onChange={handleTimeChange} />
					</div>
				</div>

				<div className="row">
					<div className="col-sm-12">
						<div className="buttonContainer d-flex flex-column">
							<WhiteButton onClick={closeModal}>{t('BSPortal_Common_Confirm')}</WhiteButton>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

export { SetFiltersModal };
